const API_BASE = process.env.REACT_APP_API || "";

export function apiFetch(path, options) {
  return fetch(`${API_BASE}${path}`, options);
}

export default apiFetch;
